import { render, staticRenderFns } from "./documentTemplateDetail.vue?vue&type=template&id=dcc61256"
import script from "./documentTemplateDetail.vue?vue&type=script&lang=js"
export * from "./documentTemplateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports